<div
  *ngIf="categoryWithSelections$ | async as categoryWithSelections"
  class="flex flex--column overflow-hidden mr-small-y white-bg border rounded-large"
>
  <div class="product-card flex">
    <div class="product-image relative" *ngIf="media">
      <fcom-image
        class="picture block flex--shrink0"
        [ratio]="'4x3'"
        [imageData]="media"
        [alt]="media?.alt"
        [fillParent]="true"
        [scale]="false"
      ></fcom-image>
    </div>
    <div class="ps-medium flex-1">
      <div class="flex flex--space-between flex--center ms-small-b">
        <div class="flex flex--middle">
          <fcom-icon *ngIf="icon" class="icon-medium ms-xsmall-r" [name]="icon"></fcom-icon>
          <h3 class="font-heading-4" [attr.id]="category + '-title'" data-testid="pax-ancillary-product-custom-title">
            {{ customProductTitle || translations?.title }}
          </h3>
        </div>
        <div class="flex">
          <fcom-icon-button
            *ngIf="showInfoButton"
            class="tooltip-button"
            [size]="IconButtonSize.SMALL"
            [theme]="IconButtonTheme.LIGHT_SECONDARY_OUTLINE"
            [icon]="{ name: SvgLibraryIcon.INFO }"
            [aria]="{
              label: 'modal.moreInfoTitle' | finLocalization,
              labelledby: category + '-title',
            }"
            (clickBtn)="openInfoModal()"
          ></fcom-icon-button>
        </div>
      </div>
      <div
        *ngIf="translations?.description"
        class="pr-medium-b font-body-1"
        [innerHTML]="translations?.description"
      ></div>
      <div class="ps-medium-t nordic-blue-100-border">
        <ng-container *ngIf="getFirstValue(categoryWithSelections) as value">
          <ng-container *ngIf="categoryWithSelections | keyvalue as entries">
            <ng-container *ngIf="entries[0]?.key as firstKey">
              <div [attr.data-testid]="'pax-ancillary-product-option-' + value.category" class="font-body-1">
                <div class="flex flex--space-between flex--center fill">
                  <div class="relative ms-xsmall-r">
                    <div
                      [ngClass]="{ hidden: (isLoading$ | async) === true }"
                      [id]="category + '-toggle-' + value.selected"
                      [attr.data-testid]="'pax-ancillary-product-price-details-' + value.category"
                      class="flex flex--column"
                    >
                      <span
                        class="flex-1 font-body-2 bold-type"
                        [attr.data-testid]="'pax-ancillary-product-price-title-' + value.category"
                      >
                        {{ translations?.actionText }}
                      </span>
                      <span
                        *ngIf="actionTextSubTitle"
                        data-testid="pax-ancillary-product-sub-title"
                        class="flex-1 font-body-2 ms-xsmall-b"
                      >
                        {{ actionTextSubTitle }}
                      </span>
                      <span
                        class="flex--shrink0 bold-type font-heading-4 nowrap"
                        [attr.data-testid]="'pax-ancillary-product-subtotal-' + value.category"
                      >
                        {{ price$ | async | finPrice }}
                      </span>
                    </div>
                    <div
                      *ngIf="(isLoading$ | async) === true"
                      class="loader-wrapper flex flex--column absolute bottom-left"
                      aria-live="polite"
                    >
                      <span class="font-body-2 bold-type ms-small-b nowrap">
                        {{ loadingTitle }}
                      </span>
                      <div class="font-heading-3 flex flex--start ms-small-l">
                        <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
                      </div>
                    </div>
                  </div>
                  <fcom-toggle-switch
                    [attr.data-testid]="category + '-toggle-' + value.selected"
                    [name]="category + '-toggle'"
                    [status]="value.selected ? ToggleSwitchStatus.ACTIVE : ToggleSwitchStatus.UNCHECKED"
                    [disabled]="(servicesReady$ | async) === false"
                    [labelledBy]="category + '-toggle-' + value.selected"
                    (statusChange)="
                      updateServiceSelection($event.status === ToggleSwitchStatus.UNCHECKED, value, firstKey)
                    "
                  ></fcom-toggle-switch>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- CARD FOOTER -->
  <div *ngIf="translations?.disclaimerText" class="nordic-blue-50-bg nordic-blue-900-text ps-xsmall-y ps-medium-x">
    <fin-content-with-modal class="block" [content]="translations?.disclaimerText"></fin-content-with-modal>
  </div>
  <ng-content></ng-content>
</div>
<fcom-modal [(open)]="infoModalOpen" [buttons]="ModalButtons.CLOSE" *ngIf="serviceInfo">
  <div class="pr-small">
    <h4 *ngIf="serviceInfo.title" class="mr-small-b">{{ serviceInfo.title }}</h4>
    <cms-unstyled-fragment
      [contentUrl$]="serviceInfo.url | finLocalization | finToObservable"
      class="block"
    ></cms-unstyled-fragment>
  </div>
</fcom-modal>
